export default "__VITE_ASSET__CEsGPDyF__"